import styles from '@/pages/backend/cardCampSettings/recruitPageSettings/index.less';
import { Modal, Space } from 'antd';
import { DeleteOutlined, MenuOutlined } from '@ant-design/icons';
import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import NameEdit from '@/pages/backend/cardCampSettings/recruitPageSettings/NameEdit';

type TImageModuleCardTitleProps = {
  id: any;
  name: string;
  fixName?: string;
  onNameChange: (id: any, name: string) => boolean;
  showEditIcon?: boolean;
  onDelete?: (id: any) => void;
  onDeleteSuccess?: () => void;
  rightCom?: ReactNode;
  className?: string;
  showMenuIcon?: boolean;
  deleteModalTitle?: string;
  deleteModelContent?: string;
  maxCount?: number;
};

const ImageModuleCardTitle: FC<TImageModuleCardTitleProps> = (props) => {
  const {
    rightCom,
    onDeleteSuccess,
    onDelete,
    name,
    onNameChange,
    id,
    fixName,
    showEditIcon = true,
    className,
    showMenuIcon = true,
    deleteModalTitle = '确认删除该宣传图模块？',
    deleteModelContent = '删除后无法恢复，请谨慎操作',
    maxCount = 10,
  } = props;
  return (
    <div className={cx(styles.image_module_inner_header, className)}>
      <Space>
        {showMenuIcon && <MenuOutlined className="text-c0c0c0" />}
        {fixName ? (
          fixName
        ) : (
          <NameEdit
            maxCount={maxCount}
            showEditIcon={showEditIcon}
            defaultValue={name}
            onNameChange={(name) => onNameChange(id, name)}
          />
        )}
      </Space>
      {rightCom || (
        <DeleteOutlined
          className="text-c0c0c0"
          onClick={(e) => {
            e.stopPropagation();
            Modal.confirm({
              okType: 'danger',
              title: deleteModalTitle,
              content: deleteModelContent,
              okText: '删除',
              onOk: async () => {
                await onDelete?.(id);
                onDeleteSuccess?.();
              },
            });
          }}
        />
      )}
    </div>
  );
};
export default ImageModuleCardTitle;
